<template>
  <form id="frm_action">
    <div class="p-formgrid">



      <template v-if="mode=='add'">
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right txt-required  padding-left-text">Car code</label>
            <div class="p-col ">
              <v-select :clearable="false" title="Property" class="" @search="SearchCarForBuy" @input="fetchCarDetails"
                placeholder="Choose" v-model="obj_data.car_code" :options="listCarBuys" label="plate_number"
                :reduce="item => item.id">
                <span slot="no-options" @click="$refs.select.open = false">Empty data</span>

                <template slot="option" slot-scope="car_buy_item">
                  {{ `[${car_buy_item.code}] ${car_buy_item.plate_number}` }}
                </template>

                <template slot="selected-option" slot-scope="car_buy_item">
                  {{ `[${car_buy_item.code}] ${car_buy_item.plate_number}` }}
                </template>
              </v-select>

              <input class="input_tmp_validator" id="car_code">
            </div>
          </div>
        </div>

        <div class="col-6 d-flex">
          <div class="p-card-field" style="flex: 1; padding-right: 10px;">
            <label class="p-col-fixed txt-right padding-left-text ">Price</label>
            <div class="p-col padding-left-text-carcode">
              <InputText disabled='true' id="price" type="text" v-model="obj_data.price" />
            </div>
          </div>
          <div class="p-card-field" style="flex: 1; padding-left: 10px;">
            <label class="p-col-fixed txt-right padding-left-text ">Color</label>
            <div class="p-col padding-left-text-carcode">
              <InputText disabled='true' id="color" type="text" v-model="obj_data.color" />
            </div>
          </div>
        </div>

        <div class="col-6 d-flex">
          <div class="p-card-field" style="flex: 1; padding-right: 10px;">
            <label class="p-col-fixed txt-right padding-left-text ">Make</label>
            <div class="p-col padding-left-text-carcode">
              <InputText disabled='true' id="make" type="text" v-model="obj_data.make" />
            </div>
          </div>
          <div class="p-card-field" style="flex: 1; padding-left: 10px;">
            <label class="p-col-fixed txt-right padding-left-text ">Showroom</label>
            <div class="p-col padding-left-text-carcode">
              <InputText disabled='true' id="showroom" type="text" v-model="obj_data.showroom" />
            </div>
          </div>
        </div>
      </template>




      <!--  :disabled="obj_data.rental_order.booking_status === 'Reject' || obj_data.rental_order.booking_status === 'Complete'" -->
      <template v-if="mode=='edit'">
        <div class="col-6">
          <div class="p-card-field">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Status</label>
            <div class="p-col">
              <v-select :clearable="false" title="Property" class=""
                :disabled="obj_data.rental_order.booking_status === 'Sold'" placeholder="Choose"
                v-model="obj_data.rental_order.booking_status" :options="listStatus" :reduce="item => item.id"
                label="name" @input="handleStatusChange">
                <span slot="no-options" @click="$refs.select.open = false">
                  Empty data
                </span>
              </v-select>
              <input class="input_tmp_validator" id="status">
            </div>
          </div>

          <!-- bảng đó nằm ở đây -->
          <div class="car-info-table">
            <div class="info-row">
              <div class="info-label">Car code</div>
              <div class="info-value color_carcode1">{{ obj_data.car_code }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Car status</div>
              <div class="info-value">{{ obj_data.status }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Price</div>
              <div class="info-value">{{ obj_data.price }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">License plate number / Colour</div>
              <div class="info-value">{{ obj_data.license_plate }} / {{ obj_data.color }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Make / Model / Build</div>
              <div class="info-value">{{ obj_data.make }} / {{ obj_data.model }} / {{ obj_data.build }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Showroom</div>
              <div class="info-value">{{ obj_data.showroom_name }}</div>
            </div>
            <div class="info-row">
              <div class="info-label">Created date</div>
              <div class="info-value">{{obj_data.created_date }}</div>
            </div>
          </div>


        </div>

      </template>

      <div class="col-6 pt-4">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right padding-left-text">CONTACT INFOMATION</label>
          <div class="p-col">
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed padding-left-text" :class="mode != 'edit' ? 'txt-required':''">User</label>
          <div class="p-col ">
            <v-select :disabled="mode=='edit'" :clearable="false" title="Property" class="" @search="SearchUser"
              placeholder="Choose" v-model="obj_data.user" :options="listUser" label="fullname" @input="fetchUser">
              <span slot="no-options" @click="$refs.select.open = false" :reduce="item => item.id">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="user">
          </div>
        </div>

        <div class="p-card-field ">
          <label class="p-col-fixed txt-required padding-left-text">Full name </label>
          <div class="p-col padding-visit-contact">
            <InputText id="fullname" type="text" v-model="obj_data.fullname" />
          </div>
        </div>

        <div class="p-card-field ">
          <label class="p-col-fixed txt-required padding-left-text">Phone number </label>
          <div class="p-col padding-visit-contact">
            <InputText id="phone" type="number" v-model="obj_data.phone" @input="formatPhoneNumber"/>
          </div>
        </div>

        <div class="p-card-field ">
          <label class="p-col-fixed txt-required padding-left-text">Email </label>
          <div class="p-col padding-visit-contact">
            <InputText id="email" type="text" v-model="obj_data.email" />
          </div>
        </div>

        <div class="p-card-field ">
          <label class="p-col-fixed txt-required padding-left-text">Appointment </label>
          <div class="p-col padding-visit-contact-apointment">
            <Calendar :showOnFocus="false" dateFormat="dd/mm/yy" :showIcon="true" appendTo="self" :showClear="true"
              :minDate="today" :manualInput="false" v-model="obj_data.apointment" placeholder="DD/MM/YYYY" />
            <input class="input_tmp_validator" id="apointment" />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right padding-left-text">Note</label>
          <div class="p-col padding-visit-contact">
            <Textarea id="note" class="" v-model="obj_data.note" placeholder="Input" :rows="5">
            </Textarea>
          </div>
        </div>

      </div>



      <!--             v-if="obj_data.rental_order.booking_status === 'Sold'"                 -->
      <template v-if="mode==='edit' && obj_data.rental_order.booking_status === 'Sold'">
        <div class="col-6">
          <div class="p-card-field">
            <label class="indam-car-for-sell p-col-fixed txt-right ">ORDER INFOMATION</label>
            <div class="p-col">
            </div>
          </div>
        </div>
        <div class="col-6" style="display: flex; gap: 20px;">
          <div style="flex: 1;">
            <div class="p-col" style="display: flex; gap: 10px;">
              <div style="flex: 1;">
                <label class="css-bold-text padding-order-info txt-right ">Order amount</label>
                <div class="p-inputgroup">
                  <InputText id="BUY_A_CAR_CUMULATIVE_SPENDING" v-model="obj_data.order_amount" :disabled="true"
                    placeholder="0" />
                  <span class="p-inputgroup-addon">$</span>
                </div>
              </div>
              <div style="flex: 1;">
                <label class="css-bold-text padding-order-info txt-right">Points reward</label>
                <div class="p-inputgroup">
                  <InputText id="POINTS_REWARD_BUY" v-model="formattedPointWallet" placeholder="0" :disabled="true" />
                  <span class="p-inputgroup-addon">point</span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-6" style="display: flex; gap: 20px;">
          <div style="flex: 1;">
            <div class="p-col" style="display: flex; gap: 10px;">
              <div style="flex: 1;">
                <label class="css-bold-text padding-order-info txt-right ">Promo code</label>
                <div class="p-inputgroup promocode-order-info">
                  <InputText class="height-input-order123" id="BUY_A_CAR_CUMULATIVE_SPENDING" v-model="obj_data.voucher_code" :disabled="true"
                    placeholder="-" />
                </div>
              </div>
              <div style="flex: 1;">
                <label class="css-bold-text padding-order-info txt-right">Redeemed</label>
                <div class="p-inputgroup">
                  <InputText id="POINTS_REWARD_BUY" v-model="obj_data.redeemed" placeholder="0" :disabled="true" />
                  <span class="p-inputgroup-addon">point</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- rating -->

        <template v-if="filteredRatings.length">
          <div class="col-6 p-3">
            <div class="p-card-field">
              <label class="indam-car-for-sell p-col-fixed txt-right padding-title-review">REVIEW & RATING</label>
            </div>
          </div>

          <div class="col-6 padding-review-rating">
            <div class="review-rating-container" v-for="rating in filteredRatings" :key="rating.id">
              <div class="review-content">
                <div class="rating">
                  <!-- Display stars based on number_rate -->
                  <span class="star">
                    <!-- Filled stars -->
                    <span v-for="n in rating.number_rate" :key="`filled-${rating.id}-${n}`">
                      <i class="fas fa-star"></i>
                    </span>
                    <!-- Empty stars -->
                    <span v-for="n in 5 - rating.number_rate" :key="`empty-${rating.id}-${n}`">
                      <i class="far fa-star"></i>
                    </span>
                  </span>
                  <!-- Display the created date -->
                  <span class="date">
                    - {{ new Date(rating.created_at).toLocaleDateString() }} {{ new
                    Date(rating.created_at).toLocaleTimeString() }}
                  </span>
                </div>
                <!-- Display the review text -->
                <p class="review-text">
                  {{ rating.note }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="p-card-field div_check">
              <div class="p-col checkbox">
                <Checkbox v-model="obj_data.rental_order.hide_rate" :binary="true" />
                <label class="p-col-fixed txt-right text">Hide this review</label>
              </div>
            </div>
          </div>
        </template>


      </template>




      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>


      <Dialog :header="dialogHeader" :visible.sync="showDeleteDialogComplete" :contentStyle="{ overflow: 'visible' }"
        :modal="true">
        <p>Changing the sale request to “SOLD” will permanently change the car’s status<br> to “SOLD OUT”. This action
          cannot be undone. Are you sure you want to<br> continue?</p>



        <div class="p-card-field ">
          <label class=" txt-right" style="font-weight: 700;">Promo code</label>
          <div class="p-inputgroup dialog-sold-input">
            <InputText class="width-promocde" v-model="promo_code_voucher" id="promo_code_voucher" placeholder="Enter promo code (if any)">
            </InputText>
          </div>
        </div>
        <div class="p-card-field ">
          <label class=" txt-right" style="font-weight: 700;">Redeem</label>
          <div class="p-inputgroup dialog-sold-input">
            <InputText class="width-promocde" type="number" v-model="redeem" id="redeem" placeholder="enter points to redeem (if any)" 
           
            />
          
          </div>
        </div>
        <!-- <div class="p-card-field ">
          <label class=" txt-right" style="font-weight: 700;">Redeem</label>
          <div class="p-inputgroup dialog-sold-input padding-redeem-left">
            <InputNumber :min="0" v-model="redeem" id="redeem" placeholder="Enter points to redeem (if any)"
              @Input="ValidateInput"></InputNumber>
          </div>
        </div> -->

        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class=" txt-right txt-required" style="font-weight: 700;">Order amount</label>
            <div class="p-inputgroup" style="width: 100%;">
              <input v-model="obj_data.order_amount" :min="0" id="order_amount" placeholder="0" @input="updatePoints"
                class="form-input full-width-input"
                @blur="obj_data.order_amount = formatNumber(obj_data.order_amount)" 
                />
              <span class="p-inputgroup-addon value-input">$</span>
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class=" txt-right" style="font-weight: 700;">Points reward</label>
            <div class="p-inputgroup" style="width: 100%;">
              <input :value="formatNumber(obj_data.point_user)" type="text" id="point_user"
                class="form-input full-width-input" placeholder="0" disabled />
              <span class="p-inputgroup-addon value-input">point</span>
            </div>
          </div>
        </div>

        <template #footer>
          <Button label="Cancel" @click="showDeleteDialogComplete = false" icon="pi pi-times"
            class="p-button-secondary" />
          <Button label="Confirm" @click="ConfirmComplete()" icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog" />
        </template>
      </Dialog>


    </div>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices';
import moment from "moment-timezone";
export default {
  components: {

  },
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      showDeleteDialog: false,
      showDeleteDialogComplete: false,
      dataBookingRound: [],
      selCarbuy: null,
      listCarBuys: [],
      listCarBuyAll: [],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local: moment.tz.guess(true),
      componentKey: 0,
      listUser: [],
      selUser: null,
      obj_data: {
        car_code: null,
        price: null,
        color: null,
        make: null,
        showroom: null,
        user: null,
        fullname: null,
        phone: null,
        email: null,
        apointment: null,
        buy_preferred_date: null,
        active: true,
        price_sale: 0,
        point_user: 0,
        order_amount  : 0,
      },
      listUserAll: [],
      users: [],
      listStatus: [
        {
          id: 1,
          name: "Booking",
        },
        {
          id: 2,
          name: "Pending",
        },
        {
          id: 3,
          name: "Sold",
        },
        {
          id: 4,
          name: "Cancel",
        },
      ],
      Reason: '',
      ListSetting: [],
      BUY_A_CAR_CUMULATIVE_SPENDING: 0,
      POINTS_REWARD_BUY: 0,
      today: new Date(),
      user_id : null,
      listLoyaltyLevel : [],
      listVoucher : [],
      listUseVoucher : [],
      promo_code_voucher : '',
      redeem : null,
      Voucher_by_code : {},
      validationErrors: {},
      listVoucherCustomer : [],
      Rating: [],
      filteredRatings: [],
      listUserComplete : [],
      initialBookingStatus: null,
    }
  },

  computed: {
    dialogHeader() {
      return `Change status #${this.obj_data?.rental_order?.code}`;
    },
    formattedPrice: {
      get() {
        return this.formatNumber(this.obj_data.order_amount);
      },
      set(value) {
        const amount = parseFloat(value.replace(/,/g, ''));
        if (isNaN(amount)) {
          this.obj_data.order_amount = '';
        } else {
          this.obj_data.order_amount = amount;
          this.updatePoints();
        }
      },
    },

    formattedPoints() {
      return this.formatNumber(this.obj_data.point_user);
    },
    formattedPriceSale: {
      get() {
        // Format giá trị price_sale thành chuỗi có dấu phẩy
        return this.formatNumber(this.obj_data.order_amount);
      },
      set(value) {
        // Chuyển giá trị về số nguyên khi người dùng nhập
        this.obj_data.order_amount = parseInt(value.replace(/,/g, ''), 10);
      }
    },
    formattedPointWallet: {
      get() {
        // Format giá trị point_wallet thành chuỗi có dấu phẩy
        return this.formatNumber(this.obj_data.rental_order.point_reward);
      },
      set(value) {
        // Chuyển giá trị về số nguyên khi người dùng nhập
        this.obj_data.rental_order.point_reward = parseInt(value.replace(/,/g, ''), 10);
      }
    }
  },
  async mounted() {
    this.getListSetting();
    this.getListUserActive();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      this.getRating();
      this.filterRatingsByRentalOrder();
      this.user_id = this.obj_data?.rental_order?.user?.id ?? null;
      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa', this.obj_data);
      this.initialBookingStatus = this.obj_data.rental_order.booking_status; // Lưu trữ trạng thái ban đầu

      if (this.obj_data?.rental_order?.booking_status === 'BOOKING_BUY' ) {
          this.obj_data.rental_order.booking_status = 'Booking'; 
      } else if (this.obj_data?.rental_order?.booking_status === 'PENDING_BUY') {
          this.obj_data.rental_order.booking_status = 'Pending'; 
      } else if (this.obj_data?.rental_order?.booking_status === 'SOLD_BUY') {
          this.obj_data.rental_order.booking_status = 'Sold'; 
      } else if (this.obj_data?.rental_order?.booking_status === 'CANCEL_BUY') {
          this.obj_data.rental_order.booking_status = 'Cancel';
      } 
      this.obj_data.car_code = this.obj_data?.car_for_sell?.code ?? null;
      this.obj_data.status = this.obj_data?.car_for_sell?.status ?? null;
      if (this.obj_data.car_for_sell.status === 'FOR_SELL') {
        this.obj_data.status = 'For sell';
      } else if (this.obj_data.car_for_sell.status === 'SOLD_OUT_SELL') {
        this.obj_data.status = 'Sold out';
      } else if (this.obj_data.car_for_sell.status === 'CANCEL_SELL') {
        this.obj_data.status = 'Cancel';
      }
      this.obj_data.price = this.formatPrice(this.obj_data?.car_for_sell?.price) ?? null;
      this.obj_data.license_plate = this.obj_data?.car_for_sell?.plate_number ?? null;
      this.obj_data.color = this.obj_data?.car_for_sell?.obj_colour?.name ?? null;
      this.obj_data.make = this.obj_data?.car_for_sell?.obj_vehicle_category?.name ?? null;
      this.obj_data.model = this.obj_data?.car_for_sell?.model ?? null;
      this.obj_data.build = this.obj_data?.car_for_sell?.build ?? null;
      this.obj_data.showroom_name = this.obj_data?.car_for_sell?.obj_showroom?.name ?? null;
      this.obj_data.created_date = this.formatDate(this.obj_data?.created_at) ?? null;
      this.obj_data.user = this.obj_data?.rental_order?.user?.fullname ?? null;
      this.obj_data.fullname = this.obj_data?.buy_name ?? null;
      this.obj_data.phone = this.obj_data?.buy_phone ?? null;
      this.obj_data.email = this.obj_data?.buy_email ?? null;
      this.obj_data.order_amount = this.formatNumber(this.obj_data?.amount_order) ?? null;
      console.log('11111111111111111111111111111', this.obj_data);
      
      if (this.obj_data.buy_preferred_date) {
        const dateParts = this.obj_data.buy_preferred_date.split('-');
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Tháng trong JavaScript bắt đầu từ 0
        const day = parseInt(dateParts[2], 10);
        const dateObject = new Date(year, month, day);

        this.obj_data = {
          ...this.obj_data,
          apointment: dateObject
        };
      } else {
        this.obj_data = {
          ...this.obj_data,
          apointment: null
        };
      }


      console.log('this.obj_data.apointmentthis.obj_data.apointment', this.obj_data.apointment);
      
      this.obj_data.note = this.obj_data?.rental_order?.note ?? null;
      this.getUsersById();
      this.getListVoucher();
      this.getListLoyaltyLevel();
      this.fetchCarDetails();
      this.fetchUser();

      this.componentKey++;
    } else {
      //thêm mới
      this.obj_data = {
        active: true,
        ordinal: 1,
      };
      this.componentKey++;
    }
    await this.getListCarBuy();
    await this.getListUser();
  },
  watch: {
    'obj_data.price': function (newVal, oldVal) {
      console.log(oldVal);
      
      this.formatPrice(newVal);
    },
    redeem(newVal) {
    const redeemInput = document.getElementById("redeem");
    if (newVal) {
      if (parseInt(newVal) < 50) {
        redeemInput.setCustomValidity("Please enter a minimum of 50 points");
      } else if (parseInt(newVal) > this.obj_data.user.point_wallet) {
        redeemInput.setCustomValidity(`Please enter a score less than or equal to ${this.obj_data.user.point_wallet} points`);
      } else {
        redeemInput.setCustomValidity(""); 
      }
    } else {
      redeemInput.setCustomValidity("");
    }
    redeemInput.reportValidity();
  }
  },
  beforeDestroy() {
    this.restoreInitialBookingStatus(); // Khôi phục trạng thái ban đầu
  },
  _methods: {
    restoreInitialBookingStatus() {
    this.obj_data.rental_order.booking_status = this.initialBookingStatus;
  },
    formatPhoneNumber(event) {
      const input = event.target.value;
      const formattedInput = input.replace(/[^0-9]/g, '');
      this.obj_data.phone = formattedInput;
    },
    async ConfirmComplete() {
      console.log('this.obj_data.rental_order.uid',this.obj_data.rental_order.user.id);
      
      this.validationErrors = {};
      const promoCodeInput = document.getElementById("promo_code_voucher");
      const orderAmountInput = document.getElementById("order_amount");
      console.log('orderAmountInputorderAmountInputorderAmountInput',orderAmountInput);
      
      // const redeemInput = document.getElementById("redeem");
      const voucher = this.listVoucher.find(v => v.code === this.promo_code_voucher);
      if (this.promo_code_voucher && !voucher) {
        promoCodeInput.setCustomValidity("Promo code is invalid");
      } else {
        promoCodeInput.setCustomValidity("");
      }
      if (this.$commonFuction.isEmptyObject(this.obj_data.order_amount) || this.obj_data.order_amount <= 0) {
        orderAmountInput.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        orderAmountInput.setCustomValidity("");
      }
      const form = document.getElementById("frm_action");
      if (!form.checkValidity()) {
        form.reportValidity();
        return true;
      }

      
      if (voucher) {
        this.Voucher_by_code = voucher;
        const loyaltyLevelKey = await this.getListLoyaltyLevel();
        if (loyaltyLevelKey === false) {
          switch (this.Voucher_by_code.type_apply_customer) {
            case 3: { 
              const voucherCustomer = this.listVoucherCustomer.find(v =>
                v.uid === this.obj_data.user.id && v.voucher_id === this.Voucher_by_code.id
              );
              if (!voucherCustomer) {
                promoCodeInput.setCustomValidity("This user is not part of a customer voucher");
              }
              break;
            }
            case 2: { 
              const getListVoucherLoyalty = async () => {
                const where_key = {
                  deleted: { _eq: false },
                  voucher_id: { _eq: this.Voucher_by_code.id }
                };
                const list = await this.$CoreService.getListVoucherLoyalty(where_key);
                this.listVoucherLoyalty = list.list;
              };
              await getListVoucherLoyalty();
              const applicableLoyaltyIds = this.listVoucherLoyalty
                .filter(v => v.voucher_id === this.Voucher_by_code.id)
                .map(v => v.loyalty_id);
              const id_loyalty = await this.getListLoyaltyLevel();
              if (!applicableLoyaltyIds.includes(id_loyalty)) {
                promoCodeInput.setCustomValidity("This user does not belong to the applicable level of the voucher");
              }
              break;
            }
            case 1: { 
              const isVoucherForAll = this.listVoucherAll.some(v =>
                v.voucher_id === this.Voucher_by_code.id
              );
              if (!isVoucherForAll) {
                promoCodeInput.setCustomValidity("This voucher is not applicable to all");
              }
              break;
            }
            default:
              promoCodeInput.setCustomValidity("Voucher type unknown");
          }
        } else {
          console.log('data voucher', this.Voucher_by_code);
          switch (this.Voucher_by_code.type_apply_customer) {
            case 3: { 
              const getListVoucherCustomer = async () => {
                const where_key = {
                  deleted: { _eq: false },
                  voucher_id: { _eq: this.Voucher_by_code.id }
                };
                const list = await this.$CoreService.getListVoucherCustomer(where_key);
                this.listVoucherCustomer = list.list;
              };
              await getListVoucherCustomer();
              const applicableCustomerIds = this.listVoucherCustomer
                .filter(v => v.voucher_id === this.Voucher_by_code.id)
                .map(v => v.uid);
              console.log('applicableCustomerIds:', applicableCustomerIds);
              if (!applicableCustomerIds.includes(this.obj_data.user.id)) {
                promoCodeInput.setCustomValidity("This user is not part of a customer voucher");
              } else {
                promoCodeInput.setCustomValidity(""); 
              }
              break;
            }
            case 2: {
              const getListVoucherLoyalty = async () => {
                const where_key = {
                  deleted: { _eq: false },
                  voucher_id: { _eq: this.Voucher_by_code.id }
                };
                const list = await this.$CoreService.getListVoucherLoyalty(where_key);
                this.listVoucherLoyalty = list.list;
              };
              await getListVoucherLoyalty();
              const applicableLoyaltyIds = this.listVoucherLoyalty
                .filter(v => v.voucher_id === this.Voucher_by_code.id)
                .map(v => v.loyalty_id);
              const id_loyalty = await this.getListLoyaltyLevel();
              if (!applicableLoyaltyIds.includes(id_loyalty)) {
                promoCodeInput.setCustomValidity("This user does not belong to the applicable level of the voucher");
              }
              break;
            }
            default: {
              console.log('data voucher', this.Voucher_by_code);
            }
          }
        }
      } 
      if (this.Voucher_by_code.valid_end) {
        const validEndDate = new Date(this.Voucher_by_code.valid_end);
        if (validEndDate < new Date()) {
          promoCodeInput.setCustomValidity("Voucher has expired");
        }
      }
      if (this.Voucher_by_code.limit_use === true) {
        const getListUseVoucher = async () => {
          const where_key = {
            deleted: { _eq: false },
          };
          const list = await this.$CoreService.getListUseVoucher(where_key);
          this.listUseVoucher = list.list;
        };
        await getListUseVoucher();
        const applicableVoucherIds = this.listUseVoucher.filter(v => v.voucher_id === this.Voucher_by_code.id && v.uid === this.obj_data.user.id);
        if (applicableVoucherIds.length > 0) {
          promoCodeInput.setCustomValidity("Voucher has expired");
        }
      }
      if (this.Voucher_by_code.type_condition === 2) {
        promoCodeInput.setCustomValidity("This voucher applies to rent");
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return true;
      }
      var is_validate = await this.validateData();
      console.log('is_validate', is_validate);
      await this.saveData();
      if (is_validate == false) {

        
        if (!this.obj_data?.rental_order?.user?.id) {
          throw new Error('Rental order UID is missing.');
        }

        const pointUser = parseInt(this.obj_data?.point_user?.toString().replace(/,/g, ''), 10);
        const userId = this.obj_data.rental_order.uid;
        const user = this.listUserComplete.find(user => user.id === userId);
        if (user) {
          user.point_wallet += parseInt(this.obj_data.point_user.toString().replace(/,/g, ''), 10);
        }
      
        if (this.obj_data.rental_order.user.id != null) 
        console.log('this.obj_data?.point_userthis.obj_data?.point_user',this.obj_data.point_user);
        {
          console.log('this.obj_data.rental_order.user.id', this.obj_data.rental_order.user.id);
          console.log('điểm nhập', pointUser);
          console.log(' điểm lưu', user.point_wallet);
          
          var point_update_user = user.point_wallet
          console.log('point_update_user', point_update_user);
          
          // await this.$apollo.mutate({
          //   mutation: DataServices.updateData('users'),
          //   variables: {
          //     'data_update': { point_wallet : point_update_user },
          //     'where_key': { 'id': { '_eq': this.obj_data.rental_order.user.id } }
          //   }
          // });
        }

        this.obj_data.order_amount = parseFloat(this.obj_data.order_amount.replace(/,/g, ''));
        this.showConfirmDialog = false;
        let variables = {
          'data_update': { 
            amount_order: this.obj_data.order_amount, 
            voucher_code: this.promo_code_voucher, 
            redeemed: this.redeem,

          },
          'where_key': {
            'id': { '_eq': this.obj_data.id }
          }
        }
        let variables_rental_order = {
          'data_update': { 
            booking_status: 'SOLD_BUY',
          point_reward: pointUser,
           },
          'where_key': {
            'id': { '_eq': this.obj_data.rental_order_id }
          }
        }
        await this.$apollo.mutate({
          mutation: DataServices.updateData('rental_order_buy'),
          variables: variables
        })
        await this.$apollo.mutate({
          mutation: DataServices.updateData('rental_order'),
          variables: variables_rental_order
        })

        await this.$apollo.mutate({
          mutation: DataServices.updateData('car_for_sell'),
          variables: {
            'data_update': { status: 'SOLD_OUT_SELL' },
            'where_key': {
              'id': { '_eq': this.obj_data?.car_for_sell?.id }
            }
          }
        })

        if(this.redeem>0){
          var params_change_point = {
            uid:this.obj_data?.rental_order?.uid,
            description: `Redeemed - With purchase #${this.obj_data?.rental_order?.code} `,
            amount:-parseFloat(this.redeem),
            updated_by:this.obj_data?.rental_order?.uid,
            created_by:this.obj_data?.rental_order?.uid,
            type: '2',
            object_id: this.obj_data?.rental_order?.id,
            status: 'ST002'
        }
        await this.$CoreService.changePoint(params_change_point);
        var list_user = [this.obj_data?.rental_order?.uid]
 var params_noti_point ={
                title:"",
                content:"",
                short_content:`[#${this.obj_data?.rental_order?.code}] Points redeemed! You used ${-parseFloat(this.redeem)} points. `,
                short_content_noti:`[#${this.obj_data?.rental_order?.code}] Points redeemed! You used ${-parseFloat(this.redeem)} points.`,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.POINT_HISTORY,
                uid:null,
                multi_uid:list_user,
                //object_id:params.rental_order_id,
                is_admin:false,
                key_noti:1,//
              }
               await this.$CoreService.sendNoti(params_noti_point);




        
        }


        this.$commonFuction.is_loading(false);
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'comfirm data successfully', life: 3000 })
      }
      this.$commonFuction.is_loading(false);
    },
    ValidateInput() {
      if (!/^\d+$/.test(this.redeem)) {
        this.redeem = ''; // Xóa đầu vào không hợp lệ
      }
    },
    ValidateInput1() {
      if (!/^\d+$/.test(this.obj_data.order_amount)) {
        this.obj_data.order_amount = ''; // Xóa đầu vào không hợp lệ
      }
    },
    async getUsersById() {
      try {
        var id = this.user_id ?? null;
        if (id === null) {
          return;
        }
        var userData = await this.$CoreService.getUsersById(id);
        if (userData) {
          this.obj_data.user = userData;
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },
    async getListLoyaltyLevel() {
      const where_key = {
        deleted: { _eq: false },
      };
      const list = await this.$CoreService.getListLoyaltyLevel(where_key);
      this.listLoyaltyLevel = list.list;
      const userPoints = this.obj_data.user.point_wallet;
      console.log('userPoints', userPoints);

      // Sắp xếp danh sách loyalty theo điểm từ cao đến thấp
      this.listLoyaltyLevel.sort((a, b) => b.earning_point_from - a.earning_point_from);

      // Tìm mức loyalty cao nhất mà userPoints lớn hơn hoặc bằng
      const closestLoyaltyLevel = this.listLoyaltyLevel.find(level => userPoints >= level.earning_point_from);

      // Trả về key của mức loyalty hoặc null nếu không có mức nào phù hợp
      if (closestLoyaltyLevel) {
        console.log('Closest loyalty level key:', closestLoyaltyLevel.id);
        return closestLoyaltyLevel.id;
      } else {
        console.log('User points are below the lowest loyalty level');
        return false;
      }
    },
    async getListVoucher() {
      var where_key = {
        deleted: { _eq: false },
      }
      var list = await this.$CoreService.getListVoucher(where_key);
      this.listVoucher = list.list;
      console.log('this.listVoucher', this.listVoucher);
    },
    async getRating() {
      var where_key = {
        deleted: { _eq: false },
      };
      var list = await this.$CoreService.getRating(where_key);
      this.Rating = list.list;
      this.filterRatingsByRentalOrder();
      console.log('this.Rating', this.Rating);
    },
    filterRatingsByRentalOrder() {
      const rentalId = this.obj_data.rental_order.id;
      console.log('rentalId', rentalId);
      
      this.filteredRatings = this.Rating.filter(rating => rating.obj_id === rentalId);
    },
    updatePoints() {
      this.ValidateInput1();
      console.log('this.obj_data.order_amount', this.obj_data.order_amount);
      const amount = parseFloat(this.obj_data.order_amount);
      if (isNaN(amount) || amount <= 0) {
        this.obj_data.point_user = 0;
        return;
      }
      const threshold = parseFloat(this.BUY_A_CAR_CUMULATIVE_SPENDING);
      const pointsPerThreshold = parseFloat(this.POINTS_REWARD_BUY);

      if (isNaN(threshold) || isNaN(pointsPerThreshold) || threshold <= 0) {
        console.warn("Invalid threshold or pointsPerThreshold values");
        this.obj_data.point_user = 0;
        return;
      }
      
      // Tính toán điểm thưởng
      const points = Math.floor(amount / threshold) * pointsPerThreshold;
      this.obj_data.point_user = points;

      console.log('this.obj_data.point_user', this.obj_data.point_user);
    },

    formatNumber(value) {
      if (!value) return '0';
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatPrice(value){
      return value = '$' + parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '$0.00';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    async getListSetting() {
      var where_key = {
        deleted: { _eq: false },
        key: { _in: ['BUY_A_CAR_CUMULATIVE_SPENDING', 'POINTS_REWARD_BUY'] }
      };
      var list = await this.$CoreService.getListSetting(where_key);
      this.ListSetting = list.list;
      this.ListSetting.forEach(element => {
        if (element.key === 'BUY_A_CAR_CUMULATIVE_SPENDING') {
          this.BUY_A_CAR_CUMULATIVE_SPENDING = element.value;
        }
        if (element.key === 'POINTS_REWARD_BUY') {
          this.POINTS_REWARD_BUY = element.value;
        }
      });
      console.log('this.BUY_A_CAR_CUMULATIVE_SPENDING', this.BUY_A_CAR_CUMULATIVE_SPENDING);
      console.log('this.POINTS_REWARD_BUY', this.POINTS_REWARD_BUY);

      console.log('this.ListSetting', this.ListSetting);
    },
    handleStatusChange(newStatus) {
      if (newStatus === 3) {
        this.showDeleteDialogComplete = true;
      } else {
        this.showDeleteDialogComplete = false; 
      }
    },
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
      // this.componentKey++;
    },
    async toCalendar() {
      this.$router.push(`/admin/list-booking?view=calendar&propery_id=${this.selCarbuy?.id}`);
    },
    async fetchCarDetails() {
      // Tìm xe dựa trên `car_code` đã chọn
      const selectedCar = this.listCarBuys.find(car => car.id === this.obj_data.car_code);
      console.log("Selected car:", selectedCar);

      if (selectedCar) {
        this.obj_data.price =  this.formatNumber(selectedCar.price) || 'N/A';
        this.obj_data.color = selectedCar.obj_colour ? selectedCar.obj_colour.name : 'N/A';
        this.obj_data.make = selectedCar.name || 'N/A';
        this.obj_data.showroom = selectedCar.obj_showroom ? selectedCar.obj_showroom.name : 'N/A';
        this.obj_data.showroom_id = selectedCar.obj_showroom ? selectedCar.obj_showroom.id : null;
      }
    },
    async fetchUser() {
      console.log("Selected user ID:", this.listUser);
      console.log("Selected user ID1:", this.obj_data.user);

      // Tìm user dựa trên `user` đã chọn
      const selectedUser = this.listUser.find(user => user.id === this.obj_data.user.id);
      console.log("Selected user:", selectedUser);

      if (selectedUser) {
        this.obj_data.fullname = selectedUser.fullname || 'N/A';
        this.obj_data.phone = selectedUser.phone || 'N/A';
        this.obj_data.email = selectedUser.email || 'N/A';
      }
    },
    async getListCarBuy() {

      var where_key = {
        deleted: { _eq: false },
        status: { _eq: 'FOR_SELL' }
      };
      let { data } = await this.$apollo.query({
        query: DataServices.getList('car_for_sell', { "fields": `id code status name plate_number showroom_id make_vehicle_category_id price color_id obj_showroom {id name} obj_colour {id name } obj_vehicle_category { id name }` }),
        variables: {
          where_key: where_key,
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      });
      var list = data[Object.keys(data)];
      var list_car_buy = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (!e?.booking?.id || (this.selCarbuy?.id && this.selCarbuy?.id == e.id)) {
          list_car_buy.push({ id: e.id, name: e.name, code: e.code, status: e.status, plate_number: e.plate_number, price: e.price, obj_showroom: e.obj_showroom, obj_colour: e.obj_colour, obj_vehicle_category: e.obj_vehicle_category, make: e.obj_vehicle_category?.name, showroom: e.obj_showroom?.name, color: e.obj_colour?.name });
        }
      }
      this.listCarBuys = list_car_buy;
      this.listCarBuyAll = list_car_buy;
    },
    async SearchUser(search, loading) {
      console.log("Loading:", loading);
      console.log("Search term:", search);
      if (search && search.trim() !== '') {
        var where_key = {
          deleted: { _eq: false },
          role: { _eq: 'user' },
          is_verify_email: { _eq: true },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key._or = [
            { fullname: { _ilike: `%${search}%` } },
            { email: { _ilike: `%${search}%` } }
          ];
        }
        try {
          var list = await this.$CoreService.getListUser1(where_key);
          if (list && list.list) {
            this.listUser = list.list;
            console.log("Filtered list data:", this.listUser);
          } else {
            this.listUser = [];
            console.log("No data found for the search term.");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          this.listUser = [];
        }
      } else {
        this.listUser = this.listUserAll;
      }
    },
    async getListUserActive() {
      var where_key = {
        deleted: {
          _eq: false,
        },
        id : { _eq: this.obj_data?.rental_order?.uid }
      }
      var list = await this.$CoreService.getListUserActive(where_key);
      this.listUserComplete = list.list;
      console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb', this.listUserComplete);
      
    },
    async getListUser() {

      var where_key = {
        deleted: { _eq: false },
        role: { _eq: 'user' },
        is_verify_email: { _eq: true },
      };
      let { data } = await this.$apollo.query({
        query: DataServices.getList('users', { "fields": `id fullname email phone` }),
        variables: {
          where_key: where_key,
          orderBy: [{ created_at: 'desc' }]
        },
        fetchPolicy: "network-only"
      });
      var list = data[Object.keys(data)];
      var list_assign = [];
      for (let i = 0; i < list.length; i++) {
        const e = list[i];
        list_assign.push({ id: e.id, fullname: e.fullname, email: e.email, phone: e.phone });
      }
      this.listUser = list_assign;
      console.log("list_assign:", this.listUser);
    },
    async formatPriceAUD(value) {
      if (isNaN(value)) return "N/A";
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2,
      }).format(value);
    },

    async SearchCarForBuy(search, loading) {
      console.log("Loading:", loading);
      console.log("Search term:", search);
      if (search && search.trim() !== '') {
        var where_key = {
          deleted: { _eq: false },
          status: { _eq: 'FOR_SELL' }
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key._or = [
            { name: { _ilike: `%${search}%` } },
            { plate_number: { _ilike: `%${search}%` } },
            { code: { _ilike: `%${search}%` } }
          ];
        }
        try {
          var list = await this.$CoreService.getListCarBuy(where_key);
          if (list && list.list) {
            this.listCarBuys = list.list;
            console.log("Filtered list data:", this.listCarBuys);
          } else {
            this.listCarBuys = [];
            console.log("No data found for the search term.");
          }
        } catch (error) {
          console.error("Error fetching car data:", error);
          this.listCarBuys = [];
        }
      } else {
        this.listCarBuys = this.listCarBuyAll;
      }
    },


    backToList() {
      
      this.$emit('back');
    },
   async validateData() {
      this.validationErrors = {};


      const fieldsToValidate = [
        { id: "car_code", value: this.obj_data.car_code },
        { id: "user", value: this.obj_data.user },
        { id: "fullname", value: this.obj_data.fullname },
        { id: "phone", value: this.obj_data.phone },
        { id: "apointment", value: this.obj_data.apointment },
        { id: "odometer", value: this.obj_data.odometer },
      ];
      
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else {
            inputElement.setCustomValidity("");
          }
        }
      }
     let status_booking = this.obj_data?.rental_order?.booking_status;
     if (status_booking === 3 || status_booking === 'Sold') {
       if (this.$commonFuction.isEmpty(this.obj_data.order_amount) || this.obj_data.order_amount <= 0) {
         this.showDeleteDialogComplete = true;
         isFormInvalid = true;
       }
     }

      let email_add = document.getElementById("email");
      if (this.$commonFuction.isEmpty(this.obj_data.email)){
        email_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      }else {
        // console.log("this.IsEmail(this.email)",this.IsEmail(this.email))
        if(!await this.$commonFuction.IsEmail(this.obj_data.email)){
          email_add.setCustomValidity("Please enter the email in the correct format");
        }else{
          email_add.setCustomValidity("");
        }
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },

    async saveData() {
     this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
       this.$commonFuction.is_loading(false);
       return;
     }


    //  let status_booking = this.obj_data?.rental_order?.booking_status;  
    //  if (status_booking === 3 || status_booking === 'Sold') {
    //   await this.ConfirmComplete();
    //  }

     const apointmentDate = moment(this.obj_data.apointment, "DD/MM/YYYY", true);
     const formattedApointment = apointmentDate.isValid() ? apointmentDate.format("YYYY-MM-DD") : null;
    //  this.obj_data["order_amount"] = parseFloat(this.obj_data["order_amount"].replace(/,/g, ''));
     var params = {
        ...this.obj_data,
        promo_code_voucher: this.promo_code_voucher,
        redeem: this.redeem,
        order_amount: this.obj_data.order_amount,
        point_user: this.obj_data.point_user,
        car_code: this.obj_data.car_code,
        user: this.obj_data.user.id,
        apointment: formattedApointment,
        ref_uid : this.obj_data?.rental_order?.ref_uid,
      };
      // this.obj_data.created_date 
      console.log("ffffffffffffffffffffff", params);
      
      this.$emit('save', params);
    },
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
}
</script>

<style lang="scss">

.color_carcode1 {
  color: #0A67FE!important;
  // thêm gạch chân
  text-decoration: underline;
}

.car-info-table {
  background-color: #f9f9f9;
  padding: 10px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 8px;
  margin-top: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.info-label {
// font: normal normal normal 16px/21px Segoe UI;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
letter-spacing: 0px;
color: #666666;
opacity: 1;
}

.info-value {
  color: var(---000000);
  text-align: right;
  font-family: Segoe UI, Regular;
  letter-spacing: 0px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #000000;
  opacity: 1;
  font-weight: 500;
}
.info-value a {
  color: #0061FE;
  opacity: 100%;
} 



// 
.p-formgrid {
  padding-top: 15px;
}

.main-style-button {
  background: #0578ad;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}


.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: rgb(0, 0, 0) !important;
  }
}

.p-col-fixed {
  font-weight: 700;
}






.full-width-input {
  width: 100%;
  /* Chiếm toàn bộ chiều rộng của khung chứa */
  padding: 0.5rem;
  /* Khoảng cách bên trong */
  font-size: 1rem;
  /* Kích thước chữ */
  box-sizing: border-box;
  /* Đảm bảo padding không làm tăng kích thước tổng thể */
  border: 1px solid #626567;
}

//rating
.review-rating-container {
  border: 1px solid #e0e0e0;
  padding: 15px;
  border-radius: 5px;
  background-color: #f9f9f9;
  font-family: Arial, sans-serif;
}

.rating {
  font-size: 16px;
  color: #ffcc00; /* Color for the stars */
}

.date {
  font-size: 14px;
  color: #888;
  margin-left: 10px;
}

.review-text {
  font-size: 14px;
  color: #333;
  margin-top: 5px;
}

.checkbox {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.text {
  font-size: 14px;
  color: #333;
}
.main-style-button {
  background: #FFDF01 !important;
}


.padding-visit {
  padding-left: 9px;
}
.padding-left-text {
  padding-left: 0 !important; 
}

.padding-visit-contact {
  padding-left: 4px;
  padding-right: 12px;
}


.padding-left-text-carcode {
  padding-left: 4px !important;
  padding-right: 12px !important;  
}
.padding-visit-contact-apointment {
  padding-left: 4px;
}
.padding-review-rating {
  padding-left: 23px !important;
  padding-right: 23px !important;
}
.padding-order-info {
  font-weight: 700;

}
.height-input-text {
  height: 38px !important;
}
.dialog-sold-input {
  height: 48px !important;
  width: 100% !important;
}

.padding-redeem-left .p-inputnumber .p-inputtext {
  padding: 0 !important;
  margin : 0 !important;
}
.value-input {
  width: 50px !important;
}


// .p-inputgroup .p-inputtext, .p-fluid .p-inputgroup .p-inputtext, .p-inputgroup .p-inputwrapper, .p-fluid .p-inputgroup .p-input {
//     flex: 1 1 auto;
//     width: 1%;
//     margin-top: 0 !important;
//     height: 48px !important;
//     margin-left: 0 !important;
// }

// .padding-title-review {
//   padding-left: 15px !important;
// }

// .height-input-order123 {
//   height: 48px !important;
// }

.width-promocde {
  width: 100% !important;
}
</style>
